export const errorRoutesNames = {
  notFound: () => "NotFound",
};
export const errorRoutes: any = {
  path: "/:catchAll(.*)?",
  component: () => import("@/shared/ui/layouts/DefaultLayout.vue"),
  meta: {
    auth: true,
  },
  children: [
    {
      path: "",
      name: errorRoutesNames.notFound(),
      component: () => import("@/shared/ui/views/errors/Error404.vue"),
    },
  ],
};
